import { useEffect, useRef, type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { AppLoader } from './AppLoader'

const AUTH_URL = ((import.meta as any).env?.VITE_AUTH_URL as string || '').replace(/\/$/, '')

function WeTookLoadingScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background">
      <AppLoader />
    </div>
  )
}

export default function RequireAuth({ children }: { children: ReactNode }) {
  const { user, hasSession, loading } = useAuth()
  const redirectedRef = useRef(false)

  // The marker cookie is the source of truth: if the backend set it, the user
  // is signed in. We render the app immediately and let /auth/me fill in user
  // details in the background — no round trip to auth.wetook.net required.
  // Only when the marker is missing AND the /auth/me probe has finished do
  // we bounce — once — to the auth subdomain to actually sign in.
  useEffect(() => {
    if (hasSession || loading || user) return
    if (redirectedRef.current) return
    redirectedRef.current = true
    if (AUTH_URL) {
      window.location.replace(
        `${AUTH_URL}/login?callback=${encodeURIComponent(window.location.href)}`,
      )
    }
  }, [user, hasSession, loading])

  if (hasSession || user) return <>{children}</>
  if (loading) return <WeTookLoadingScreen />
  if (AUTH_URL) return <WeTookLoadingScreen />
  return <Navigate to="/login" replace />
}
